/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface InvalidateTenantCache1Request {
    tenantId: string;
}

export interface InvalidateUserCache1Request {
    userId: string;
}

/**
 * ComprehensivePermissionsCacheApi - interface
 * 
 * @export
 * @interface ComprehensivePermissionsCacheApiInterface
 */
export interface ComprehensivePermissionsCacheApiInterface {
    /**
     * Clears all comprehensive permissions cache entries (Redis and fallback)
     * @summary Clear all cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivePermissionsCacheApiInterface
     */
    clearAllCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clears all comprehensive permissions cache entries (Redis and fallback)
     * Clear all cache
     */
    clearAllCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns current comprehensive permissions cache configuration settings
     * @summary Get cache configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivePermissionsCacheApiInterface
     */
    getCacheConfigurationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns current comprehensive permissions cache configuration settings
     * Get cache configuration
     */
    getCacheConfiguration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns comprehensive permissions cache statistics including Redis and fallback cache sizes
     * @summary Get cache statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivePermissionsCacheApiInterface
     */
    getCacheStatistics2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns comprehensive permissions cache statistics including Redis and fallback cache sizes
     * Get cache statistics
     */
    getCacheStatistics2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Invalidates all comprehensive permissions cache entries for a specific tenant
     * @summary Invalidate tenant cache
     * @param {string} tenantId Tenant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivePermissionsCacheApiInterface
     */
    invalidateTenantCache1Raw(requestParameters: InvalidateTenantCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Invalidates all comprehensive permissions cache entries for a specific tenant
     * Invalidate tenant cache
     */
    invalidateTenantCache1(requestParameters: InvalidateTenantCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Invalidates all comprehensive permissions cache entries for a specific user
     * @summary Invalidate user cache
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComprehensivePermissionsCacheApiInterface
     */
    invalidateUserCache1Raw(requestParameters: InvalidateUserCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Invalidates all comprehensive permissions cache entries for a specific user
     * Invalidate user cache
     */
    invalidateUserCache1(requestParameters: InvalidateUserCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class ComprehensivePermissionsCacheApi extends runtime.BaseAPI implements ComprehensivePermissionsCacheApiInterface {

    /**
     * Clears all comprehensive permissions cache entries (Redis and fallback)
     * Clear all cache
     */
    async clearAllCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/comprehensive-permissions-cache/clear`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears all comprehensive permissions cache entries (Redis and fallback)
     * Clear all cache
     */
    async clearAllCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearAllCacheRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns current comprehensive permissions cache configuration settings
     * Get cache configuration
     */
    async getCacheConfigurationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/comprehensive-permissions-cache/configuration`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns current comprehensive permissions cache configuration settings
     * Get cache configuration
     */
    async getCacheConfiguration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCacheConfigurationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns comprehensive permissions cache statistics including Redis and fallback cache sizes
     * Get cache statistics
     */
    async getCacheStatistics2Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/comprehensive-permissions-cache/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns comprehensive permissions cache statistics including Redis and fallback cache sizes
     * Get cache statistics
     */
    async getCacheStatistics2(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCacheStatistics2Raw(initOverrides);
        return await response.value();
    }

    /**
     * Invalidates all comprehensive permissions cache entries for a specific tenant
     * Invalidate tenant cache
     */
    async invalidateTenantCache1Raw(requestParameters: InvalidateTenantCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling invalidateTenantCache1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/comprehensive-permissions-cache/invalidate/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Invalidates all comprehensive permissions cache entries for a specific tenant
     * Invalidate tenant cache
     */
    async invalidateTenantCache1(requestParameters: InvalidateTenantCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.invalidateTenantCache1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidates all comprehensive permissions cache entries for a specific user
     * Invalidate user cache
     */
    async invalidateUserCache1Raw(requestParameters: InvalidateUserCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling invalidateUserCache1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/comprehensive-permissions-cache/invalidate/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Invalidates all comprehensive permissions cache entries for a specific user
     * Invalidate user cache
     */
    async invalidateUserCache1(requestParameters: InvalidateUserCache1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.invalidateUserCache1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
